import React, { lazy } from "react";
import { authRoles } from "../../auth/authRoles";

const TenantsModules = lazy(() => import("./TenantsModule")
);

const TenantsModuletRoutes = [
  {
    path: "/tenants-module",
    element: <TenantsModules/>,
    auth: authRoles.admin,
  },
];

export default TenantsModuletRoutes;